import { sapOdpDatasetMetadata } from 'app/registries/dataset/sap-odp-dataset-metadata';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';
import {
    IDatasetTypeMetadata,
    IDynamicDatasetTypeMetadata
} from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';
import { GlobalVariables } from 'app/services/globals';

/**
 * @deprecated
 */
export const sapCdcDatasetMetadata: IDynamicDatasetTypeMetadata = async (injector) => {
    const metadata: IDatasetTypeMetadata = {
        ...(await sapOdpDatasetMetadata(injector)),
        isSource: GlobalVariables.enableSapCdcCopy,
        supportLinkedServiceTypes: GlobalVariables.enableSapCdcCopy
            ? [adfModelTypeMap.sapCdc.linkedServiceType]  // override in trident
            : [adfModelTypeMap.sapOdp.linkedServiceType, adfModelTypeMap.sapCdc.linkedServiceType],
        schemaAlias: __IS_FABRIC_DPE__  ? 'contextName' : 'context',
        type: adfModelTypeMap.sapCdc.datasetType,
        supportDataFlowSink: false,
        supportDataFlowSource: false
    };
    return metadata;
};
